<template>
  <div style="margin-top: 20px">
    <el-form :model="formData" :rules="formRules" ref="formRef" size="small" label-width="80px" style="text-align: left; padding-right: 20px">
      <el-form-item label="角色" prop="role_id" :error="errMsg.role_id">
        <el-select v-model="formData.role_id" placeholder="请选择" style="width: 350px">
          <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户名" prop="username" :error="errMsg.username">
        <el-input v-model="formData.username" style="width: 350px"> </el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password" :error="errMsg.password">
        <el-input v-model="formData.password" :placeholder="formData.id > 0 ? '留空不修改' : ''" style="width: 350px"> </el-input>
        <span style="display: block">8位以上必须含数字大小写字母</span>
      </el-form-item>
    </el-form>
    <div class="form-but">
      <el-button type="success" @click="saveData">保存</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'userEdit',
  created() {},
  data() {
    var verifyPassword = (rule, value, callback) => {
      console.log(value)
      if (this.formData.id == 0 && (value == undefined || value == '')) {
        callback(new Error('密码不能为空'))
      }
      if (value != undefined && value != '') {
        var regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/
        if (value != undefined && !regex.test(value)) {
          callback(new Error('密码不符合规则'))
        }
      }
      callback()
    }
    return {
      errMsg: {},
      roles: [],
      formData: { id: 0, username: '', password: '', role_id: '' },
      formRules: {
        role_id: [{ required: true, message: '请选择角色', trigger: 'change' }],
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ validator: verifyPassword, trigger: 'blur' }]
      }
    }
  },
  methods: {
    //获取数据
    async getData() {
      await this.$api.auth.roleList().then(res => {
        if (res.code == 200) {
          this.roles = res.data ? res.data : []
        }
      })
    },
    //保存
    async saveData() {
      this.$refs.formRef.validate(async vaild => {
        if (vaild) {
          this.initErrMsg()
          await this.$api.auth.userSave(this.formData).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              this.$emit('callMethod')
            } else {
              for (let k in res.data) {
                this.errMsg[k] = res.data[k]
              }
            }
          })
        }
      })
    },
    //父页面传数据
    setData(data) {
      if (data == undefined) {
        this.formData = { id: 0, username: '', password: '', role_id: '' }
      } else {
        this.formData = Object.assign({}, data)
      }
      console.log(this.formData, data)
      this.getData()
      this.initErrMsg()
      this.$refs.formRef.clearValidate()
    },
    //初始化错误信息对象
    initErrMsg() {
      this.errMsg = {}
      this.$refs.formRef.fields.map(i => {
        this.$set(this.errMsg, i.prop, '')
      })
    }
  }
}
</script>
